<div class="dialogContainer">
  <div class="header">
    <h2>Tag Maintenance</h2>
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  <div class="content">
    <div class="tableWrapper" [ngClass]="getMessageClass()">
      @for (message of messages(); track message) {
        <div>{{ message }}</div>
      }
    </div>
  </div>
  <div mat-dialog-actions>
    <span>
      <button matButton="elevated" (click)="getTemplate()">Download Template</button>
      <input class="fileInput" type="file" #fileSelection id="fileSelection"
        (change)="fileChange($event);fileSelection.value=''"/>
      <label for="fileSelection">Select File</label>
    </span>
    <span class="spacer"></span>
    <span>
      <button matButton="elevated" (click)="cancel()">Cancel</button>
      @if (!saveResponse()) {
        <button matButton="elevated" [disabled]="!isReadyToUpload()" (click)="saveTagging()">Save Tags</button>
      }
    </span>
  </div>
</div>
